import Vue from 'vue'
import debounce from 'lodash/debounce'

import afterHeader from './filters-after-header'
Vue.component(afterHeader.name, afterHeader)

export default {
    slots() {
        return [
            {
                slot: "after-header",
                component: afterHeader.name,
                condition(attrs) {
                    if( ! this.displayFilter ) {
                        return false
                    }

                    if( this.filter === '*' ) {
                        return true
                    }

                    let filterColumns = attrs.columns.filter( col => col.filter || inArray(col.field, this.filter) )

                    return filterColumns.length > 0
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayFilter: {
                    type: Boolean,
                    default: true
                },
                filter: {
                    type: [Array, String],
                    default: () => []
                },
                filterModel: {
                    type: [Object, Boolean],
                    default: false
                },
                filterButtonText: {
                    type: String,
                    default: 'Filter'
                },
                filterButtonUseIcon: {
                    type: Boolean,
                    default: true
                },
                filterResetButtonText: {
                    type: String,
                    default: 'Reset'
                },
                filterUseRouter: {
                    type: Boolean,
                    default: true
                },
                filterParam : {
                    type: String,
                    default: 'flt_'
                },
                filterApplyOnStartup: {
                    type: Boolean,
                    default: false
                }
            },
            data() {
                return {
                    conditionsState: {}
                }
            },
            created() {
                if( this.conditionsState.filters === undefined ) {
                    Vue.set(this.conditionsState, 'filters', {})
                }

                let debounced_onChange = debounce(function(conditions) {
                    this.$emit('change', conditions)
                }.bind(this), 100)

                this.$off('change-internal').$on('change-internal', debounced_onChange)
            }
        }
    }
}
